import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialState = {
	document: data,
	spoList: data,
	xml: data,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.DOWNLOAD_DOC:
			return { ...state, document: { ...data, loading: true } }

		case types.DOWNLOAD_DOC_DONE:
			return { ...state, document: { ...data, success: true, data: payload } }

		case types.DOWNLOAD_DOC_FAIL:
			return { ...state, document: { ...data, failed: true } }

		case types.SET_XML:
			return { ...state, xml: { ...data, loading: true } }

		case types.SET_XML_DONE:
			return { ...state, xml: { ...data, success: true, data: payload } }

		case types.SET_XML_FAIL:
			return { ...state, xml: { ...data, failed: true } }

		case types.GET_SPO_LIST:
			return { ...state, spoList: { ...data, loading: true } }

		case types.GET_SPO_LIST_DONE:
			return { ...state, spoList: { ...data, success: true, data: payload } }

		case types.GET_SPO_LIST_FAIL:
			return { ...state, spoList: { ...data, failed: true } }

		default:
			return state
	}
}
